import type { Price, Product, Stock } from '@maestro/data-layer'

import { apiGet } from '@maestro/core/api-client'

export function getProductsByIds(ids: string[]): Promise<Product[]> {
  return apiGet<Product[]>('/api/products', { ids: ids.join(',') })
}

export function getProductDetailsById<T>(
  productId: string,
  fields?: string[]
): Promise<T> {
  return apiGet<T>(`/api/products/${encodeURIComponent(productId)}/details`, {
    fields: fields?.join(','),
  })
}

export function getProductsStockByIds(
  productIds: string[],
  baseProductId?: string
): Promise<Record<string, Stock>> {
  return apiGet<Record<string, Stock>>('/api/products/stock', {
    ids: [...productIds].sort().join(','),
    baseProductId,
  })
}

export function getProductsPriceByIds(
  productIds: string[],
  baseProductId?: string
): Promise<Record<string, Price>> {
  return apiGet<Record<string, Price>>('/api/products/price', {
    ids: [...productIds].sort().join(','),
    baseProductId,
  })
}
